import React from 'react';
import styled from 'styled-components';
import { useAppSelector } from '@src/core/hooks';
import { productSelector } from '@src/stores/product';
import { BodyLarge } from '@src/fonts/typography/Typography';
import { DarkTextColor } from '@src/fonts/typography/TypographyColors';
import useTranslate from '@src/i18n/useTranslate';
import ProductAdderAdditionalCard from './ProductAdderAdditionalCard';
import ProductAdderFooterButtons from './ProductAdderFooterButtons';
import ProductAdderOngoingCartResume from './ProductAdderSummary';
import useSelectedProductId from '@src/hooks/useSelectedProductId';

interface ProductAdderAdditionalsProps {
  isMultiProductFlow?: boolean;
}

const ProductAdderAdditionals = (props: Readonly<ProductAdderAdditionalsProps>) => {
  const { isMultiProductFlow = false } = props;
  const productId = useSelectedProductId();
  const { i18n } = useTranslate();
  const product = useAppSelector(productSelector(productId));
  const additionals = product?.additionals || [];

  return (
    <>
      <AdditionalsArea>
        <ProductAdderOngoingCartResume />
        <AdditionalsSubLabel>{i18n('adder_additionals')}</AdditionalsSubLabel>
        <AdditionalCards>
          {additionals.map((additional) => (
            <ProductAdderAdditionalCard key={additional.id} additional={additional} />
          ))}
        </AdditionalCards>
      </AdditionalsArea>
      <ProductAdderFooterButtons showValue isMultiProductFlow={isMultiProductFlow} />
    </>
  );
};

const AdditionalsArea = styled.div`
  position: relative;
  margin-bottom: 16px;
`;
const AdditionalCards = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 24px;
  margin-top: 8px;
`;

const AdditionalsSubLabel = styled.p`
  ${BodyLarge}
  ${DarkTextColor}
    margin-top: 24px;
`;

export default ProductAdderAdditionals;
